import {
  API_STATES
} from '@/helpers'
  
const state = {
  autoschedulingSettingsUpdateState : API_STATES.NOT_REQUESTED,
  autoschedulingSettingsUpdateError : null,
  shiftPriority                     : []
}

export default state
  